"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _HBTooltip = _interopRequireDefault(require("../HBTooltip/HBTooltip"));
var _Ai = _interopRequireDefault(require("@honeybook/icons/dist/icons/Ai12"));
var _Ai2 = _interopRequireDefault(require("@honeybook/icons/dist/icons/Ai16"));
var _Ai3 = _interopRequireDefault(require("@honeybook/icons/dist/icons/Ai24"));
var _AiOutline = _interopRequireDefault(require("@honeybook/icons/dist/icons/AiOutline12"));
var _AiOutline2 = _interopRequireDefault(require("@honeybook/icons/dist/icons/AiOutline16"));
var _AiOutline3 = _interopRequireDefault(require("@honeybook/icons/dist/icons/AiOutline24"));
var iconMap = {
  'filled-xs': _Ai["default"],
  'filled-sm': _Ai2["default"],
  'filled-md': _Ai3["default"],
  'outline-xs': _AiOutline["default"],
  'outline-sm': _AiOutline2["default"],
  'outline-md': _AiOutline3["default"]
};
var HBIndicatorAI = function HBIndicatorAI(_ref) {
  var _iconMap$key;
  var size = _ref.size,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'filled' : _ref$theme,
    _ref$tooltipContent = _ref.tooltipContent,
    tooltipContent = _ref$tooltipContent === void 0 ? '' : _ref$tooltipContent,
    _ref$tooltipProps = _ref.tooltipProps,
    tooltipProps = _ref$tooltipProps === void 0 ? {} : _ref$tooltipProps,
    className = _ref.className,
    color = _ref.color,
    testId = _ref.testId;
  var key = "".concat(theme, "-").concat(size);
  var shouldApplyCustomFill = theme === 'outline' && color;
  var iconProps = {
    className: className,
    useDefaultFill: shouldApplyCustomFill ? false : true,
    'data-testid': testId
  };
  if (theme === 'outline' && color) {
    iconProps.fill = color;
    iconProps.color = color;
  }
  var icon = (_iconMap$key = iconMap[key]) === null || _iconMap$key === void 0 ? void 0 : _iconMap$key.call(iconMap, iconProps);
  if (!tooltipContent) {
    return icon;
  }
  return /*#__PURE__*/_react["default"].createElement(_HBTooltip["default"], (0, _extends2["default"])({
    target: icon
  }, tooltipProps), tooltipContent);
};
var _default = exports["default"] = HBIndicatorAI;
//# sourceMappingURL=HBIndicatorAI.js.map